import React, { Component } from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, PieChart, Pie, Sector, Cell, BarChart, Bar, ReferenceLine } from 'recharts';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import axios from 'axios';
import moment from 'moment';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import orange from '@material-ui/core/colors/orange';
import yellow from '@material-ui/core/colors/yellow';
import blue from '@material-ui/core/colors/blue';
import deepPurple from '@material-ui/core/colors/deepPurple';
import indigo from '@material-ui/core/colors/indigo';
import teal from '@material-ui/core/colors/teal';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import cyan from '@material-ui/core/colors/cyan';
import pink from '@material-ui/core/colors/pink';
import red from '@material-ui/core/colors/red';
import lime from '@material-ui/core/colors/lime';
import lightGreen from '@material-ui/core/colors/lightGreen';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import numeral from 'numeral';
import { selectEntryTotal, formattedEntriesTotal, positiveNumber, entryTypeBalance } from '../../selectors/entriesTotal';
import getVisibleEntries from '../../selectors/entries';
import DashBoardWidget from './DashBoardWidget';
import LoadingPage from '../loading/LoadingPage';
import { WEEKLY_ENTRIES_ENDPOINT, MOST_RECENT_DOWNLOAD_TIME } from '../../api/api';
import { downloadLastCSV } from '../../actions';
import ErrorBar from '../shared/ErrorBar';


const COLORS = [red[500], green[500], lime[500], pink[500], cyan[500], amber[500], green[500], teal[500], indigo[500], deepPurple[500], blue[500], yellow[500], orange[500], lightGreen[500]];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
 	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x  = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy  + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} 	dominantBaseline="central">
    	{`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  card: {
    display: 'flex',
  },
  iconHover: {
    margin: theme.spacing.unit * 2,
    flex: 1,
    textAlign: 'right'
  },
  actions: {
    display: 'flex',
  },
  divider: {
    marginRight: 20,
    marginLeft: 20
  },
  paper: {
   position: 'absolute',
   width: theme.spacing.unit * 150,
   backgroundColor: theme.palette.background.paper,
   boxShadow: theme.shadows[5],
   padding: theme.spacing.unit * 4,
   top: '20vh',
   left: '20vh'
 },
 modal: {
  overflowX: 'scroll'
 },
 graphWrapper: {
   paddingLeft: theme.spacing.unit * 2,
   paddingRight: theme.spacing.unit * 2
 },
 captionText: {
   paddingTop: theme.spacing.unit * 0.7,
   paddingBottom: theme.spacing.unit * 0.7
 },
 graphTypo: {
   borderRadius: 2.5, fontFamily: 'Roboto', fontSize: 12
 }
});


export class DashboardPage extends Component {
  state = {
    openSigTable: false,
    weekEntries: [],
    errMessages: [],
    graphLoading: true,
    lastDownloadLoading: true,
    lastReportEntries: [],
    lastReportDate: null
  };

  componentWillMount() {
    this.startGetWeekEntries();
    this.lastDownloadTime();
  }

  onOpenWithoutSigs = () => {
    this.setState({ openSigTable: true });
  };

  onCloseWithoutSigs = () => {
    this.setState({ openSigTable: false });
  };

  handleCloseError = (remove) => {
    const newErrMessages = this.state.errMessages.filter((errMessage, index) => index !== remove)
    this.setState({
      errMessages: newErrMessages
    });
  }

  async startGetWeekEntries() {
    this.setState({
      graphLoading: true
    });
    try {
      let entries = await axios({
        method: 'get',
        url: WEEKLY_ENTRIES_ENDPOINT,
        headers: JSON.parse(sessionStorage.user)
      });
      return this.setState({
        weekEntries: entries.data.reverse(),
        graphLoading: false
      });
    } catch (err) {
      console.log(err);
      if (err.response.status === 401) {
        return this.setState({ errMessage: 'You are not authorized to view entries', graphLoading: false });
      }
      return this.setState({ errMessage: err.response.data.message, graphLoading: false });
    }
  }

  async lastDownloadTime() {
    this.setState({
      lastDownloadLoading: true
    });
    try {
      let entries = await axios({
        method: 'get',
        url: MOST_RECENT_DOWNLOAD_TIME,
        headers: JSON.parse(sessionStorage.user)
      });
      const newEntries = this.props.entries.filter((entry) => {
        return entries.data.latest_records.includes(entry.id) && entry.entry_type === 'disbursement';
      });
      return this.setState({
        lastDownloadLoading: false,
        lastReportEntries: newEntries,
        lastReportDate: entries.data.created_at
      });
    } catch (err) {
      if (err.response.status === 401) {
        return this.setState({ errMessage: [...this.state.errMessage, 'You are not authorized to view entries'], lastDownloadLoading: false });
      }
      return this.setState({ errMessage: [...this.state.errMessage, err.response.data.message], lastDownloadLoading: false });
    }

  }


  renderLastSevenDayGraph() {
    if (this.state.graphLoading) {
      return (
        <LoadingPage />
      );
    } return (
      <Grid item xs={12} lg={4}>
        <Paper className={this.props.classes.graphWrapper} style={{ backgroundColor: grey[900] }}>

        <ResponsiveContainer width="100%" height={200}>
        <LineChart
          width={700}
          height={200}
          data={this.state.weekEntries}
          margin={{ top: 20, right: 15, left: 0, bottom: 5 }}
          stroke={grey[200]}
          style={styles.graphTypo}
        >
           <XAxis dataKey="day" stroke={grey[200]} />
           <YAxis yAxisId="left" stroke={grey[200]} padding={{ top: 35, right: 30 }} />
           <YAxis yAxisId="right" stroke={grey[200]} orientation="right" />
           <CartesianGrid strokeDasharray="3 3" stroke={grey[200]} />
           <Tooltip wrapperStyle={{ backgroundColor: grey[100] }} />
           <Line yAxisId="left" type="linear" dataKey="total" stroke={teal[500]} strokeWidth={4} dot={{ stroke: teal[500], strokeWidth: 4 }} />
           <Line yAxisId="right" dataKey="count" type="linear" stroke={deepPurple[500]} strokeWidth={4} dot={{ stroke: deepPurple[500], strokeWidth: 4 }} />
          </LineChart>
        </ResponsiveContainer>
        <Typography align="center" color="secondary" variant="subheading">Entries in Last 7 days</Typography>
        </Paper>
      </Grid>
    );
  }

  renderDivisionPieGraph() {
    let distribution = [
      { entry_type: "Out", count: 0 },
      { entry_type: "In", count: 0 }
    ]
    this.props.entries.forEach(entry => {
      if (entry.entry_type === 'cash_in') {
        distribution[1].count += entry.total
      } else {
        distribution[0].count -= entry.total
      }
    });

    if (this.state.graphLoading) {
      return (
        <LoadingPage />
      );
    } return (
      <Grid item xs={12} lg={4}>
        <Paper className={this.props.classes.graphWrapper} style={{ backgroundColor: grey[900] }}>

        <ResponsiveContainer width="100%" height={200}>
          <PieChart width={800} height={400} onMouseEnter={this.onPieEnter} style={styles.graphTypo}>
          <Pie
            data={distribution}
            cx={175}
            cy={100}
            dataKey="count"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={80}
            fill="#8884d8"
          >
          	{
            	distribution.map((entry, index) => <Cell key={entry.entry_type} fill={COLORS[index % COLORS.length]}/>)
            }
          </Pie>
        </PieChart>
        </ResponsiveContainer>
        <Typography align="center" variant="subheading" color="secondary">In/Out Comparison</Typography>
        </Paper>
      </Grid>
    );
  }

  renderBarGraph() {
    if (this.state.graphLoading) {
      return (
        <LoadingPage />
      );
    } return (
      <Grid item xs={12}>
        <Paper className={this.props.classes.graphWrapper} style={{ backgroundColor: grey[900] }}>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart width={800} height={300} data={this.props.divisions}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }} style={styles.graphTypo}>
           <CartesianGrid strokeDasharray="3 3"/>
           <XAxis tickLine={false} dataKey="name" stroke={grey[200]} />
           <YAxis tickLine={false} padding={{ top: 35, right: 30 }} stroke={grey[200]} />
           <ReferenceLine y={0} stroke='#000'/>
           <Bar animationEasing='ease-in'  dataKey="total" fill="#8884d8" label={{ position: 'top' }} >
           {
            this.props.divisions.map((division, index) => (
              <Cell key={division.division_code} fill={COLORS[index % 20]} />
            ))
          }
        </Bar>
          </BarChart>
        </ResponsiveContainer>
        <Typography align="center" variant="subheading" color="secondary">Balance by divisions</Typography>
        </Paper>
      </Grid>
    );
  }

  renderDownloadButton() {
    if (this.state.lastReportDate) {
      return (
        <Button size="small" onClick={() => this.props.downloadLastCSV()} style={{ fontWeight: '400' }}>Download</Button>
      )
    }
    return (
      <Button size="small" disabled style={{ fontWeight: '400' }}>N/A</Button>
    )
  }

  render() {
    const { classes, visibleEntries } = this.props;
    return (
      <div className={classes.root}>
        {/*  Sig Table*/}
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openSigTable}
          onClose={this.onCloseWithoutSigs}
          className={classes.modal}
        >
          <Paper className={classes.paper}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Entry #</TableCell>
                  <TableCell>Purpose</TableCell>
                  <TableCell numeric>Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.props.without_signature.map(n => {
                  return (
                    <TableRow key={n.id}>
                      <TableCell scope="row">
                        {moment(n.effective_date).format('MM/DD/YY')}
                      </TableCell>
                      <TableCell><Link to={`/edit/${n.id}`}>
                        <p>{n.entry_number}</p>
                      </Link></TableCell>
                      <TableCell>{n.purpose}</TableCell>
                      <TableCell numeric>{ numeral(n.total).format('$0,0.00')
                      }</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Paper>
        </Modal>

        <Grid container spacing={24}>
          <Grid item xs={12} sm={3}>
            <DashBoardWidget icon='attach_money' iconColor={yellow[500]} title='Current Balance' subtitleColor={positiveNumber(this.props.currentBalance) ? 'primary' : 'secondary'} subtitle={formattedEntriesTotal(this.props.currentBalance)}>
              <ExpansionPanel style={{ boxShadow:'none' }}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} style={{ minHeight: '30px', height: '33px' }}>
                  <Typography className={classes.heading} >BREAK DOWN</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div>
                  <Typography variant="subheading" align="right" color={positiveNumber(entryTypeBalance(visibleEntries, "cash_in")) ? 'primary' : 'secondary'}>
                    Cash In {formattedEntriesTotal(entryTypeBalance(visibleEntries, "cash_in"))}
                  </Typography>
                  <Typography variant="subheading" align="right" color={positiveNumber(entryTypeBalance(visibleEntries, "disbursement")) ? 'primary' : 'secondary'}>
                    Disbursement {formattedEntriesTotal(entryTypeBalance(visibleEntries, "disbursement"))}
                  </Typography>
                  <Typography variant="subheading" align="right" color={positiveNumber(entryTypeBalance(visibleEntries, "hand_in")) ? 'primary' : 'secondary'}>
                    Hand In {formattedEntriesTotal(entryTypeBalance(visibleEntries, "hand_in"))}
                  </Typography>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </DashBoardWidget>
          </Grid>
          <Grid item xs={12} sm={3}>
            <DashBoardWidget icon='error' iconColor={red[500]} title='Without Signature' subtitle={this.props.without_signature.length}>
              <Button onClick={this.onOpenWithoutSigs} size="small" style={{ fontWeight: '400' }}> Show </Button>
            </DashBoardWidget>
          </Grid>
          <Grid item xs={12} sm={3}>
            <DashBoardWidget icon='account_balance' iconColor='#00aa5c' title="Today's Sum" subtitleColor={positiveNumber(selectEntryTotal(this.props.dailyEntries) / 100) ? 'primary' : 'secondary'} subtitle={formattedEntriesTotal(selectEntryTotal(this.props.dailyEntries) / 100)}>
              <Typography variant="body1" className={classes.captionText}> {this.props.dailyEntries.length} {this.props.dailyEntries.length <= 0 ? `ENTRY` : 'ENTRIES'} </Typography>
            </DashBoardWidget>
          </Grid>
          <Grid item xs={12} sm={3}>

            <DashBoardWidget icon='access_time' iconColor={blue[500]} title="Latest Output" subtitle={this.state.lastReportDate ? moment(this.state.lastReportDate).format('MM/DD/YY') : 'N/A'} buttonText='Coming Soon'>
              {this.props.lastDownloadLoading ? <LoadingPage /> :
                this.renderDownloadButton()
              }

            </DashBoardWidget>
          </Grid>
            {this.renderBarGraph()}
            {this.renderLastSevenDayGraph()}
            {this.renderDivisionPieGraph()}
             <ErrorBar messages={this.state.errMessages} onClick={this.handleCloseError} />
        </Grid>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    downloadLastCSV: () => dispatch(downloadLastCSV())
  };
};

const mapStateToProps = ({ entries, filters, errors, divisions }) => {
  const without_signature = entries.filter(entry => entry.signature === null && entry.entry_type === 'disbursement');
  const { errMessage } = errors;
  const dailyEntries = getVisibleEntries(entries
  , { ...filters, startDate: moment().startOf('day'), endDate: moment().endOf('day') });
  const visibleEntries = getVisibleEntries(entries
  , { ...filters, startDate: '', endDate: '' });
  return {
    currentBalance: selectEntryTotal(entries) / 100,
    dailyEntries,
    without_signature,
    visibleEntries,
    errMessage,
    entries,
    divisions
  };
};

export default compose(
  withStyles(styles, {
    name: 'DashboardPage',
}), connect(mapStateToProps, mapDispatchToProps))(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/home/DashBoardPage.js